import styles from "./AdvancedCapabilities.module.css";
import {
    FaRegSmile,
    FaBolt,
    FaGlobe,
    FaCode,
    FaStream,
    FaBrain
} from "react-icons/fa";

const AdvancedCapabilities = () => {
    return (
        <section className={styles.wrapper}>
            <div className={styles.container}>
                {/* Heading */}
                <h2 className={styles.title}>Advanced Capabilities</h2>
                <p className={styles.subtitle}>
                    Everything you need for production-grade voice synthesis that sounds
                    genuinely human.
                </p>

                {/* Cards Grid */}
                <div className={styles.grid}>
                    <div className={styles.card}>
                        <span className={styles.icon}><FaRegSmile /></span>
                        <h4>Human-Like Quality</h4>
                        <p>
                            Speech that’s virtually indistinguishable from real humans with
                            natural breathing, pauses, and conversational flow.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <span className={styles.icon}><FaBrain /></span>
                        <h4>Emotional Expression</h4>
                        <p>
                            15+ emotional tones including empathetic, professional, cheerful,
                            urgent, and calm for contextually appropriate responses.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <span className={styles.icon}><FaBolt /></span>
                        <h4>Ultra-Low Latency</h4>
                        <p>
                            Sub-100ms time-to-first-byte. Optimized for real-time voice
                            conversations, not batch processing.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <span className={styles.icon}><FaGlobe /></span>
                        <h4>12+ Languages</h4>
                        <p>
                            Native fluency across global languages with regional accents and
                            dialects. Multilingual capabilities per voice.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <span className={styles.icon}><FaCode /></span>
                        <h4>Code-Mixing Support</h4>
                        <p>
                            Seamlessly blend English with Hindi, Tamil, Telugu, and 9+ Indic
                            languages in their native scripts.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <span className={styles.icon}><FaStream /></span>
                        <h4>Streaming & REST</h4>
                        <p>
                            Real-time WebSocket streaming for live applications or REST API
                            for batch generation workflows.
                        </p>
                    </div>
                </div>

                {/* Emotional Intelligence Section */}
                <div className={styles.emotionSection}>
                    <div className={styles.emotionLeft}>
                        <span className={styles.badge}>Emotional Intelligence</span>
                        <h3>Multiple Emotions & Natural Expressions</h3>
                        <p>
                            Not just words—feelings. Natural coughs, sighs, and expressions
                            that make AI voices sound truly human and contextually aware.
                        </p>
                        <p className={styles.smallText}>
                            Our advanced TTS engine understands emotional context and adds
                            appropriate vocal characteristics, breathing patterns, and
                            non-verbal sounds to create authentic human-like speech.
                        </p>
                    </div>

                    <div className={styles.emotionRight}>
                        <div className={styles.emotionCard}>
                            <h5>Emotional Tones</h5>
                            <div className={styles.tags}>
                                <span>Neutral</span>
                                <span>Happy</span>
                                <span>Excited</span>
                                <span>Laughing</span>
                                <span>Sad</span>
                                <span>Angry</span>
                                <span>Whisper</span>
                                <span>Shouting</span>
                                <span>Confused</span>
                            </div>
                        </div>

                        <div className={styles.emotionCard}>
                            <h5>Non-Verbalisms</h5>
                            <div className={styles.tags}>
                                <span>Cough</span>
                                <span>Sigh</span>
                                <span>Sniffle</span>
                                <span>Yawn</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default AdvancedCapabilities;
